import './layout';

import Map from 'ol/Map';
import View from 'ol/View';
import OSM from 'ol/source/OSM';
import {Tile as TileLayer} from 'ol/layer';
import * as proj from 'ol/proj';

document.addEventListener('DOMContentLoaded', e => {

    const map = new Map({
        target: 'map_contact_1',
        layers: [
            new TileLayer({
                source: new OSM()
            })
        ],
        view: new View({
            center: proj.fromLonLat([
                4.356133718663722, 50.86073837046036
            ]),
            zoom: 18
        })

    })
});
